// src/app/[lang]/shop/carpets/[titleAtURL]/ProductDensity.jsx

'use client'


import { usePreferences } from '@/contexts/ShopPreferences.context';
import { createFormatters } from '@/lib/formatters.utils';


export default function ProductDensity({density, dict, lang}) {
  if (!density) return null;
  const { formatNumber } = createFormatters(lang, 'short');
  const { unitSystem} = usePreferences();

  return (
    <p>{dict.pileDensity}: {formatNumber(density[unitSystem].value)} {density[unitSystem].unitType}</p>
  );
}
